import { SimpleGrid, VStack } from '@chakra-ui/react';
import React from 'react';
import Card from '../../Card';
import CategoryTemplate from './CategoryTemplate';
import Goals from './Goals';

const BoxList = ({ boxes, templateId }) => {
  
  return (
    <SimpleGrid
      columns={{ base: 1, lg: 2 }}
      spacingX={2}
      spacingY={{ base: 2, lg: 2 }}
      w={'full'}
    >
      {boxes.map(box => {
        return (
          <Card
            key={box.id}
            px={2}
            py={1}
            border={'1px solid'}
            borderColor={'lightGray.500'}
          >
            <VStack w={'full'} spacing={2} h={'200px'}>
              <CategoryTemplate category={box} templateId={templateId} />
              <Goals category={box} templateId={templateId} />
            </VStack>
          </Card>
        );
      })}
    </SimpleGrid>
  );
};

export default BoxList;
